import { render, staticRenderFns } from "./evaluationList.vue?vue&type=template&id=184e8824&scoped=true&"
import script from "./evaluationList.vue?vue&type=script&lang=js&"
export * from "./evaluationList.vue?vue&type=script&lang=js&"
import style0 from "./evaluationList.vue?vue&type=style&index=0&id=184e8824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e8824",
  null
  
)

export default component.exports